const  GATSBY_RAZOR_API_URL = process.env.GATSBY_RAZOR_API_URL;
const API_HOST_V2 = `${GATSBY_RAZOR_API_URL}/v2`;
const API_HOST_V3 = `${GATSBY_RAZOR_API_URL}/v3`;

export const login = (email, password) => {
  const url = `${API_HOST_V2}/fleets/admins/token`;
  const body = {
    email,
    password,
  };
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/JSON',
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      switch (response.status) {
        case 404:
          throw new Error('User not found');
        case 401:
          throw new Error('Incorrect username or password');
        default:
          throw new Error('There was a problem with your request. Please try again later');
      }
    }
  });
};

export const getReport = (jwt, fleetId, startDate, endDate, reportType, operatorId) => {
  const url = `${API_HOST_V3}/fleet-admins/reports`;
  const body = {
    fleet_id: fleetId,
    start_date: startDate,
    end_date: endDate,
    report_type: reportType,
    operator_id: operatorId
  };
  
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  })
  .then((response) => {
    if (response.ok) {
      return response.json().then(data => {
        return data;
      });
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  })
  .catch((error) => {
    throw error;
  });
};

// For backward compatibility - maps to the new endpoint
export const getFinancialReport = (jwt, fleetId, startDate, endDate) => {
  return getReport(jwt, fleetId, startDate, endDate, 'financial');
};

export const getFinancialReportTotals = (jwt, fleetId, startDate, endDate) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/financial-report-metrics?`
   + new URLSearchParams({
    startDate: startDate,
    endDate: endDate
  });
  return fetch(url, {
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  })
  .then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  })
  .catch((error) => {
    console.error(error);
    throw error;
  });
};


export const getFleets = (jwt) => {
  const url = `${API_HOST_V2}/fleets/`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const getFleetReservations = (jwt, fleetId, month, year) => {
  let url = `${API_HOST_V2}/fleets/${fleetId}/reservations`;
  if (month !== undefined && year !== undefined) {
    url += `?${new URLSearchParams({ month, year })}`;
  }
  
  return fetch(url, {
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  })
  .then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  })
  .catch((error) => {
    console.error('Error fetching fleet reservations:', error);
    throw error;
  });
};

export const getDayFleetReservations = (jwt, fleetId, day) => {
  let url = `${API_HOST_V2}/fleets/${fleetId}/reservations`;
  url += `?${new URLSearchParams({ day })}`;
  return fetch(url, {
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  })
  .then((response) => {
    if (response.ok) {
      return response.json(); // Make sure to return the parsed JSON
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  })
  .catch((error) => {
    console.error(error);
    throw error;
  });
};

export const getVehicles = (jwt, fleetId) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/vehicles`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const getMessages = (jwt, fleetId) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/messages`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const getWaivers = (jwt, operatorId) => {
  const url = `${API_HOST_V3}/operators/${operatorId}/waivers`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const getAlerts = (jwt, fleetId) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/alerts`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (!response.ok) {
      throw new Error('There was a problem with your request. Please try again later');
    }
    return response.json();
  }).catch((error) => {
    console.error('Error fetching alerts:', error);
    throw error;
  });
};

export const removeVehicle = (jwt, fleetId, vehicleHash) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/vehicles/${vehicleHash}`;
  return fetch(url, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return true;
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const addVehicles = (jwt, fleetId, vehicleNames) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/vehicles`;
  const body = { names: vehicleNames };
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  });
};

export const updateWaiverStatus = (jwt, waiverId, waiverStatus, hasAgreedToTerms, userId = null) => {
  const url = `${API_HOST_V2}/users/waiver/${waiverId}/status`;
  const body = {  
    waiver_status: waiverStatus,
    has_agreed_to_terms: hasAgreedToTerms,
    user_id: userId
  };
  
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then(response => {
    if (!response.ok) {
      // Try to parse error response as JSON
      return response.text().then(responseText => {
        let errorMessage = `Failed to update waiver status (${response.status}: ${response.statusText})`;
        
        try {
          const errorJson = JSON.parse(responseText);
          if (errorJson.message) {
            errorMessage = errorJson.message;
          } else if (errorJson.error) {
            errorMessage = errorJson.error;
          }
        } catch (jsonError) {
          // If response is not JSON, include the raw response text if it's not empty
          if (responseText.trim()) {
            errorMessage += ` - ${responseText}`;
          }
        }
        
        throw new Error(errorMessage);
      });
    }
    
    // Handle successful response - check if there's content to parse
    return response.text().then(responseText => {
      if (responseText.trim()) {
        try {
          return JSON.parse(responseText);
        } catch (jsonError) {
          console.warn('Response was successful but not valid JSON:', responseText);
          return { success: true, message: 'Waiver status updated successfully' };
        }
      } else {
        // Empty response body, which is OK for this endpoint
        return { success: true, message: 'Waiver status updated successfully' };
      }
    });
  }).catch((error) => {
    console.error('Error updating waiver status:', error);
    throw error;
  });
};

export const postGeofence = (jwt, fleetId, params) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/geofence`;
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then(response => {
    if (!response.ok) {
      return response.json().then(errorJson => {
        throw new Error(errorJson.message || 'Failed to create Geofence');
      });
    }
    return response.json(); // assuming your API returns JSON
  });
};


export const reassignVehicleToReservation = (jwt, reservationId, params) => {
  const url = `${API_HOST_V3}/fleet-admins/reservation/${reservationId}/reassign-vehicle`;
  return fetch(url, {
    method: 'PATCH',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then(response => {
    if (!response.ok) {
      return response.json().then(errorJson => {
        throw new Error(errorJson.message || 'Failed to reassign vehicle');
      });
    }
    return response.json(); // assuming your API returns JSON
  });
};



export const lockVehicle = (jwt, vehicle_hash) => {
  const url = `${API_HOST_V2}/fleets/vehicles/${vehicle_hash}/lock`;
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then(response => {
    if (!response.ok) {
      return response.json().then(errorJson => {
        throw new Error(errorJson.message || 'Failed to lock vehicle');
      });
    }
    return response.json(); // assuming your API returns JSON
  });
};


export const unlockVehicle = (jwt, vehicle_hash) => {
  const url = `${API_HOST_V2}/fleets/vehicles/${vehicle_hash}/unlock`;
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then(response => {
    if (!response.ok) {
      return response.json().then(errorJson => {
        throw new Error(errorJson.message || 'Failed to unlock vehicle');
      });
    }
    return response.json(); // assuming your API returns JSON
  });
};



export const postPushMessage = (jwt, fleetId, message) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/push-notification`;
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(message),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  });
};

export const postAppMessage = (jwt, fleetId, message) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/app-notification`;
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(message),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  });
};

export const getUsers = (jwt, fleetId, cancelled = false) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/users?cancelled=${cancelled}`;
  return fetch(url, {
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error('There was a problem with your request. Please try again later');
      }
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

export const patchUser = (jwt, fleetId, userId, newParams) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/users/${userId}`;
  return fetch(url, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
    body: JSON.stringify(newParams),
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else if (response.status === 409) {
        throw new Error('This Phone number is already being used by another user');
      } else {
        throw new Error('There was a problem with your request. Please try again later');
      }
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

export const addNewUser = (jwt, fleetId, userData) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/users`;
  const body = {
    first_name: userData.firstName,
    last_name: userData.lastName,
    phone: userData.phoneNumber,
    has_group_rides: userData.hasGroupRides,
    return_existing_user: userData.returnExistingUser,
  };
  userData.startDate && (body.start_date = userData.startDate.toISOString());
  userData.endDate && (body.end_date = userData.endDate.toISOString());

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
    body: JSON.stringify(body),  }).then((response) => {
    return response.json().then((json) => {
      if (response.ok) {
        // The API returns { user: {...} }, so we extract the user directly
        return { success: true, user: json.user };
      } else {
        return { success: false, error: json.message || 'Unknown error occurred' };
      }
    });
  });
};

export const deleteUser = (jwt, fleetId, userId) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/users/${userId}`;
  return fetch(url, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return { success: true };
    } else {
      return response.json().then((json) => ({ success: false, error: json }));
    }
  });
};

export const forgotPassword = (email) => {
  const url = `${API_HOST_V2}/fleets/admins/forgot-password`;
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/JSON',
    },
    body: JSON.stringify({
      email,
    }),
  }).then((response) => {
    return response.json().then((json) => ({ success: response.ok, response: json }));
  });
};

export const resetPassword = (adminId, token, password) => {
  const url = `${API_HOST_V2}/fleets/admins/${adminId}/reset-password`;
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/JSON',
    },
    body: JSON.stringify({
      token,
      password,
    }),
  })
    .then((response) => {
      return response.json().then((json) => {
        return { success: response.ok, response: json };
      });
    })
    .catch((error) => {
      return { success: false, response: error };
    });
};

export const deleteGeofence = (jwt, geofenceId) => {
  const url = `${API_HOST_V2}/fleets/geofence/${geofenceId}`;
  return fetch(url, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.text().then((text) => {
        return text ? JSON.parse(text) : {};
      });
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const patchGeofence = (jwt, geofenceId, params) => {
  const url = `${API_HOST_V2}/fleets/geofence/${geofenceId}`;
  return fetch(url, {
    method: 'PATCH',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const patchZone = (jwt, zoneId, params) => {
  const url = `${API_HOST_V2}/zones/${zoneId}`;
  return fetch(url, {
    method: 'PATCH',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const patchVehicle = (jwt, vehicleHash, params) => {
  const url = `${API_HOST_V2}/vehicles/${vehicleHash}`;
  return fetch(url, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
    body: JSON.stringify(params),
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const reassignVehicleFleet = (jwt, vehicleHash, params) => {
  const url = `${API_HOST_V2}/fleets/vehicles/${vehicleHash}/reassign-fleet`;
  return fetch(url, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
    body: JSON.stringify(params),
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const getUserActiveRide = (jwt, fleetId, userId) => {

  const url = `${API_HOST_V2}/fleets/${fleetId}/users/${userId}/active-ride`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const getDashboard = (jwt, fleetId) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/dashboard`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};



export const getFleetRides = (jwt, fleetId) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/rides`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const getFleetActiveRides = (jwt, fleetId) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/active-rides`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const getUserRides = (jwt, fleetId, userId) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/users/${userId}/rides`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const getMapRides = (jwt, fleetId, date) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/map-rides${date ? `?date=${date}` : ''}`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const toggleUserActive = (jwt, fleetId, userId, isActive) => {
  const body = JSON.stringify({ is_active: isActive });
  const url = `${API_HOST_V2}/fleets/${fleetId}/users/${userId}`;
  return fetch(url, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${jwt}`,
      'Content-Type': 'application/JSON',
    },
    body,
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const toggleGroupRides = (jwt, fleetId, userId, hasGroupRides) => {
  const body = JSON.stringify({ has_group_rides: hasGroupRides });
  const url = `${API_HOST_V2}/fleets/${fleetId}/users/${userId}`;
  return fetch(url, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${jwt}`,
      'Content-Type': 'application/JSON',
    },
    body,
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const getAdmins = (jwt, fleetId) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/admins`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const getAdminAccountTypes = () => {
  const url = `${API_HOST_V2}/fleets/admin-account-types`;
  return fetch(url, {
    method: 'GET',
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const postAdmin = (jwt, fleetId, newAdmin) => {
  const body = JSON.stringify({
    first_name: newAdmin.firstName,
    last_name: newAdmin.lastName,
    password: newAdmin.password,
    email: newAdmin.email,
    phone_number: newAdmin.phoneNumber,
    account_type: newAdmin.accountType,
    waiver_alerts_enabled: newAdmin.waiverAlertsEnabled,
    reservation_alerts_enabled: newAdmin.reservationAlertsEnabled,
    vehicle_alerts_enabled: newAdmin.vehicleAlertsEnabled
  });
  const url = `${API_HOST_V2}/fleets/${fleetId}/admins`;
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
    body,
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const updateAdmin = (jwt, fleetId, adminId, updatedAdmin) => {
  const body = JSON.stringify({
    first_name: updatedAdmin.firstName,
    last_name: updatedAdmin.lastName,
    email: updatedAdmin.email,
    phone_number: updatedAdmin.phoneNumber,
    account_type: updatedAdmin.accountType,
    waiver_alerts_enabled: updatedAdmin.waiverAlertsEnabled,
    reservation_alerts_enabled: updatedAdmin.reservationAlertsEnabled,
    vehicle_alerts_enabled: updatedAdmin.vehicleAlertsEnabled,
    password: updatedAdmin.password
  });

  const url = `${API_HOST_V2}/fleets/${fleetId}/admins/${adminId}`;
  return fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
    body,
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const deleteAdmin = (jwt, fleetId, adminId) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/admins/${adminId}`;
  return fetch(url, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return true;
    } else {
      console.error('Error deleting admin:', response);
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
}

export const getFleetFeatures = (jwt, fleet_id) => {
  const url = `${API_HOST_V3}/features?fleet_id=${fleet_id}&ignore_cache=true`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const getVehicleFares = (jwt, fleet_id, vehicle_type) => {
  const url = `${API_HOST_V2}/fleets/${fleet_id}/vehicle/fares?vehicle_type=${vehicle_type}`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const endRide = (jwt, rideId, params) => {
  const url = `${API_HOST_V2}/fleets/rides/${rideId}/stop`;
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    }
  });
};

export const startRide = (jwt, params) => {
  const url = `${API_HOST_V2}/fleets/start-ride`;
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    }
  });
};


export const refundRide = (jwt, ride_id, params) => {
  const url = `${API_HOST_V2}/fleets/rides/${ride_id}/refund`;
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    }
  });
};

export const refundPartial = (jwt, ride_id, params) => {
  const url = `${API_HOST_V2}/fleets/rides/${ride_id}/refund-partial`;
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    }
  });
};


export const releaseSecurityDeposit = (jwt, ride_id) => {
  const url = `${API_HOST_V2}/fleets/rides/${ride_id}/release-security-deposit`;
  return fetch(url, {
    method: 'POST',
    //body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    }
  });
};

export const captureSecurityDeposit = (jwt, ride_id, params) => {
  const url = `${API_HOST_V2}/fleets/rides/${ride_id}/capture-security-deposit`;
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    }
  });
};

export const refundPartialReservation = (jwt, reservation_id, params) => {
  const url = `${API_HOST_V3}/fleet-admins/reservations/${reservation_id}/partial-refund`;
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    }
  });
};

export const endFleetReservation = (jwt, reservationId, params) => {
  const url = `${API_HOST_V3}/fleet-admins/reservations/${reservationId}/end`;
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then(response => {
    if (response.ok) {
      return true;
    } else {
      return response.json().then(errorJson => {
        // Extract title and message from the error response
        if (errorJson.title && errorJson.message) {
          throw new Error(errorJson.message);
        } else {
          throw new Error(errorJson.message || 'There was a problem with your request. Please try again later');
        }
      }).catch(error => {
        // If JSON parsing fails or there's another issue
        if (error.name === 'SyntaxError') {
          throw new Error('There was a problem with your request. Please try again later');
        }
        throw error;
      });
    }
  }).catch(error => {
    console.error('Error ending reservation:', error);
    throw error;
  });
};

export const activateFleetReservation = (jwt, reservationId, params) => {
  const url = `${API_HOST_V3}/fleet-admins/reservations/${reservationId}/activate/`;
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then(response => {
    if (response.ok) {
      return true;
    } else {
      return response.json().then(errorJson => {
        if (errorJson.title === 'Security Deposit Failed') {
          throw new Error(errorJson.message || 'Failed to create security deposit preauthorization.');
        } else {
          throw new Error(errorJson.message || 'There was a problem with your request. Please try again later');
        }
      });
    }
  }).catch(error => {
    console.error('Error activating reservation:', error);
    throw error;
  });
};

export const refundReservation = (jwt, reservationId, params) => {
  const url = `${API_HOST_V3}/fleet-admins/reservations/${reservationId}/refund`;
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then(response => {
    if (!response.ok) {
      throw new Error('-----There was a problem with your request. Please try again later');
    }
    return response.json(); // Assuming the response is JSON
  });
};

export const patchReservation = (jwt, reservationId, params) => {
  const url = `${API_HOST_V3}/fleet-admins/reservations/${reservationId}/patch`;
  return fetch(url, {
    method: 'PATCH',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then(response => {
    if (!response.ok) {
      return response.json().then(errorJson => {
        throw new Error(errorJson.message || 'Failed to update reservation');
      });
    }
    return response.json();
  });
};

// Manual Reservation Management Functions

/**
 * Get available vehicle types for a fleet (public endpoint, no auth required)
 * Used in CreateReservationDialog to populate vehicle type dropdown
 * @param {string} fleetId - Fleet ID
 * @param {string} startDate - Optional start date (YYYY-MM-DD) for availability check
 * @param {string} endDate - Optional end date (YYYY-MM-DD) for availability check
 * @returns {Promise<Array>} Array of vehicle types (with availability if dates provided)
 */
export const getAvailableVehicleTypes = (fleetId, startDate = null, endDate = null) => {
  const params = new URLSearchParams({ fleet_id: fleetId });
  
  // Only add date params if both are provided
  if (startDate && endDate) {
    params.append('start_date', startDate);
    params.append('end_date', endDate);
  }
  
  const url = `${API_HOST_V3}/reservation-web/available-vehicle-types?${params}`;
  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/JSON',
    },
  }).then(response => {
    if (!response.ok) {
      return response.json().then(errorJson => {
        throw new Error(errorJson.message || 'Failed to load vehicle types');
      });
    }
    return response.json();
  });
};

/**
 * Calculate reservation pricing with backend API
 * Returns fleet_fare_id needed to fetch available add-ons
 * @param {Object} params - Pricing parameters
 * @returns {Promise<Object>} Price calculation result with fleet_fare_id
 */
export const getReservationPrice = (params) => {
  const queryParams = new URLSearchParams({
    fleet_id: params.fleetId,
    start_date: params.startDate, // YYYY-MM-DD format
    end_date: params.endDate,
    vehicle_type: params.vehicleType,
    ...(params.couponId && { coupon_id: params.couponId }),
    ...(params.addonIds && params.addonIds.length > 0 && { addon_ids: params.addonIds.join(',') }),
    ...(params.qty && { qty: params.qty }),
  });
  
  const url = `${API_HOST_V3}/reservation-web/reservation-price?${queryParams}`;
  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/JSON',
    },
  }).then(response => {
    if (!response.ok) {
      return response.json().then(errorJson => {
        throw new Error(errorJson.message || 'Failed to calculate reservation price');
      });
    }
    return response.json();
  });
};

/**
 * Get available add-ons (surcharges) for a specific pricing tier
 * Must be called AFTER getReservationPrice to obtain fleet_fare_id
 * @param {string} operatorId - Operator ID (from fleet)
 * @param {number} fleetFareId - Fleet fare ID from pricing response
 * @returns {Promise<Array>} Array of available surcharges filtered for reservation_addon type
 */
export const getAvailableSurcharges = (operatorId, fleetFareId) => {
  const queryParams = new URLSearchParams({
    operator_id: operatorId,
    fleet_fare_id: fleetFareId,
  });
  
  const url = `${API_HOST_V3}/reservation-web/surcharges?${queryParams}`;
  console.log('[API] getAvailableSurcharges - Request:', {
    url,
    operatorId,
    fleetFareId
  });
  
  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/JSON',
    },
  }).then(response => {
    console.log('[API] getAvailableSurcharges - Response status:', response.status);
    if (!response.ok) {
      return response.json().then(errorJson => {
        console.error('[API] getAvailableSurcharges - Error response:', errorJson);
        throw new Error(errorJson.message || 'Failed to fetch add-ons');
      });
    }
    return response.json();
  }).then(surcharges => {
    console.log('[API] getAvailableSurcharges - Raw response (BEFORE filtering):', {
      count: surcharges?.length || 0,
      surcharges,
      sample: surcharges?.[0]
    });
    
    // Filter for reservation add-ons only (backend returns all surcharge types)
    const filtered = surcharges.filter(s => s.surcharge_type === 'reservation_addon');
    
    console.log('[API] getAvailableSurcharges - After filtering for reservation_addon:', {
      originalCount: surcharges?.length || 0,
      filteredCount: filtered.length,
      filtered,
      allSurchargeTypes: surcharges?.map(s => s.surcharge_type)
    });
    
    return filtered;
  });
};

/**
 * Validate a coupon code for a specific fleet and operator
 * @param {string} couponCode - Coupon code to validate
 * @param {number} operatorId - Operator ID
 * @param {number} fleetId - Fleet ID
 * @returns {Promise<Object>} Coupon details if valid
 */
export const validateCoupon = (couponCode, operatorId, fleetId) => {
  const queryParams = new URLSearchParams({
    code: couponCode, // Backend expects 'code' not 'coupon_code'
    operator_id: operatorId,
    fleet_id: fleetId,
  });
  
  const url = `${API_HOST_V3}/reservation-web/coupon?${queryParams}`;
  console.log('[API] validateCoupon - Request:', {
    url,
    couponCode,
    operatorId,
    fleetId
  });
  
  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/JSON',
    },
  }).then(response => {
    if (!response.ok) {
      return response.json().then(errorJson => {
        throw new Error(errorJson.message || 'Invalid coupon code');
      });
    }
    return response.json();
  }).then(data => {
    console.log('[API] validateCoupon - Response:', data);
    return data;
  });
};

/**
 * Look up user information by phone number, email, or user ID
 * Used by fleet admins to find existing users when creating reservations
 * @param {string} jwt - Admin JWT token
 * @param {Object} params - Search parameters
 * @param {number} params.fleetId - Fleet ID (required when searching by phone/email)
 * @param {string} [params.phone] - User's phone number
 * @param {string} [params.email] - User's email address
 * @param {number} [params.userId] - User's unique ID
 * @returns {Promise<Object>} User information if found
 */
export const lookupUser = (jwt, params) => {
  const queryParams = new URLSearchParams();
  
  if (params.fleetId) {
    queryParams.append('fleet_id', params.fleetId);
  }
  if (params.phone) {
    queryParams.append('phone', params.phone);
  }
  if (params.email) {
    queryParams.append('email', params.email);
  }
  if (params.userId) {
    queryParams.append('user_id', params.userId);
  }
  
  const url = `${API_HOST_V3}/fleet-admins/user?${queryParams}`;
  console.log('[API] lookupUser - Request:', {
    url,
    params
  });
  
  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then(response => {
    if (response.status === 404) {
      // User not found - return null instead of throwing
      console.log('[API] lookupUser - User not found (404)');
      return null;
    }
    if (!response.ok) {
      return response.json().then(errorJson => {
        throw new Error(errorJson.message || 'Failed to lookup user');
      });
    }
    return response.json();
  }).then(data => {
    console.log('[API] lookupUser - Response:', data);
    return data;
  });
};

/**
 * Create a new manual reservation
 * Used by fleet admins to create reservations on behalf of customers
 */
export const createManualReservation = (jwt, fleetId, reservationData) => {
  const url = `${API_HOST_V3}/fleet-admins/reservations/manual`;
  const body = {
    fleet_id: fleetId,
    ...reservationData,
  };
  console.log('[API] createManualReservation - Request:', {
    url,
    fleetId,
    reservationData,
    body,
    hasReservationId: !!body.reservation_id
  });
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then(response => {
    if (!response.ok) {
      return response.json().then(errorJson => {
        throw new Error(errorJson.message || 'Failed to create reservation');
      });
    }
    return response.json();
  });
};

/**
 * Update an existing reservation (works for ANY reservation source)
 * Allows updates to reservations from manual, web, mobile, or kiosk sources
 */
export const updateReservation = (jwt, reservationId, updateData) => {
  const url = `${API_HOST_V3}/fleet-admins/reservations/${reservationId}/update`;
  return fetch(url, {
    method: 'PATCH',
    body: JSON.stringify(updateData),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then(response => {
    if (!response.ok) {
      return response.json().then(errorJson => {
        throw new Error(errorJson.message || 'Failed to update reservation');
      });
    }
    return response.json();
  });
};

// Keep old function name for backward compatibility during transition
export const updateManualReservation = updateReservation;

/**
 * Request payment for a manual reservation
 * Generates Stripe Checkout Session link or marks as paid
 */
export const requestReservationPayment = (jwt, reservationId, paymentMethod) => {
  const url = `${API_HOST_V3}/fleet-admins/reservations/${reservationId}/request-payment`;
  const body = {
    payment_method: paymentMethod, // 'payment-link' or 'skip'
  };
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then(response => {
    if (!response.ok) {
      return response.json().then(errorJson => {
        throw new Error(errorJson.message || 'Failed to request payment');
      });
    }
    return response.json();
  });
};

export const getWaiverPdfContent = async (jwt, waiverId) => {
  const url = `${API_HOST_V2}/users/waiver/${waiverId}?pdf=true`;
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    });
    if (!response.ok) {
      throw new Error('There was a problem with your request. Please try again later.');
    }
    const data = await response.json();
    const pdfContent = data.pdfContent;
    return pdfContent;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getWaiverFiles = async (jwt, waiverId) => {
  const url = `${API_HOST_V2}/users/waiver/${waiverId}/files`;
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    });
    if (!response.ok) {
      throw new Error('There was a problem with your request. Please try again later.');
    }
    const data = await response.json();
    return data.waiver_files;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getPasskeys = (jwt, fleetId) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/passkeys`;
  return fetch(url, {
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  })
  .then((response) => {
      if (response.ok) {
        let result = response.json();
        return result;
      } else {
        throw new Error('There was a problem with your request. Please try again later');
      }
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

export const patchPasskey = (jwt, fleetId, passkeyId, newParams) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/passkeys/${passkeyId}`;
  return fetch(url, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
    body: JSON.stringify(newParams),
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else if (response.status === 409) {
        throw new Error('This Phone number is already being used by another user');
      } else {
        throw new Error('There was a problem with your request. Please try again later');
      }
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

export const addNewPasskey = (jwt, fleetId, passkeyData) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/passkeys`;
  const body = {
    passkey: passkeyData.passkey,
    metadata: passkeyData.metadata,
    is_active: passkeyData.is_active,
  };

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
    body: JSON.stringify(body),
  }).then((response) => {
    return response.json().then((json) => {
      if (response.ok) {
        return { success: true };
      } else {
        return { success: false, error: json.message || 'Unknown error occurred' };
      }
    });
  });
};

export const deletePasskey = (jwt, fleetId, passkeyId) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/passkeys/${passkeyId}`;
  return fetch(url, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return { success: true };
    } else {
      return response.json().then((json) => ({ success: false, error: json }));
    }
  });
};

export const togglePasskeyActive = (jwt, fleetId, passkeyId, isActive) => {
  const body = JSON.stringify({ is_active: isActive });
  const url = `${API_HOST_V2}/fleets/${fleetId}/passkeys/${passkeyId}`;
  return fetch(url, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${jwt}`,
      'Content-Type': 'application/JSON',
    },
    body,
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const toggleAlerts = (jwt, fleetId, userId, alertType, isEnabled) => {
  const body = JSON.stringify({ alert_type: alertType, enabled: isEnabled });
  const url = `${API_HOST_V2}/fleets/${fleetId}/admins/${userId}/alerts`;
  return fetch(url, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${jwt}`,
      'Content-Type': 'application/JSON',
    },
    body,
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });  
};

export const toggleWaiverAlerts = (jwt, fleetId, userId, isActive) => {
  return toggleAlerts(jwt, fleetId, userId, 'waiver', isActive);
};

export const toggleReservationAlerts = (jwt, fleetId, userId, isEnabled) => {
  return toggleAlerts(jwt, fleetId, userId, 'reservation', isEnabled);
};

export const toggleVehicleAlerts = (jwt, fleetId, userId, isEnabled) => {
  return toggleAlerts(jwt, fleetId, userId, 'vehicle', isEnabled);
};

export const changeAdminAccountType = (jwt, fleetId, userId, accountType) => {
  const body = JSON.stringify({ account_type: accountType });
  const url = `${API_HOST_V2}/fleets/${fleetId}/admins/${userId}/account-type`;
  return fetch(url, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${jwt}`,
      'Content-Type': 'application/JSON',
    },
    body,
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });  
}

export const getCoupons = (jwt, fleetId) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/coupons`;
  console.log('getCoupons: Making API call to:', url);
  return fetch(url, {
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  })
  .then((response) => {
      if (response.ok) {
        let result = response.json();
        return result.then(data => {
          console.log('getCoupons: API response data:', JSON.stringify(data, null, 2));
          return data;
        });
      } else {
        console.error('getCoupons: API response not ok, status:', response.status);
        throw new Error('There was a problem with your request. Please try again later');
      }
    })
    .catch((error) => {
      console.error('getCoupons: Error occurred:', error);
      throw error;
    });
};

export const patchCoupon = (jwt, fleetId, couponId, newParams) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/coupons/${couponId}`;
  return fetch(url, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
    body: JSON.stringify(newParams),
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error('There was a problem with your request. Please try again later');
      }
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

export const addNewCoupon = (jwt, fleetId, couponData) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/coupons`;
  const body = { ...couponData };
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
    body: JSON.stringify(body),
  })
    .then((response) => {
      if (response.ok) {
        return { success: true };
      } else if (response.status === 409) {
        // Handle 409 Conflict error
        return { success: false, error: 'This Coupon Code is already used. Please enter a new Coupon Code' };
      } else {
        // For other errors, attempt to parse the error message if available
        return response.text().then((text) => {
          let errorMessage = 'Unknown error occurred';
          if (text) {
            const json = JSON.parse(text);
            if (json && json.message) {
              errorMessage = json.message;
            } 
          }
          return { success: false, error: errorMessage };
        });
      }
    })
    .catch((error) => {
      // Handle network errors or unexpected exceptions
      return { success: false, error: error.message || 'Unknown error occurred' };
    });
};


export const deleteCoupon = (jwt, fleetId, couponId) => {
  const url = `${API_HOST_V2}/fleets/${fleetId}/coupons/${couponId}`;
  return fetch(url, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return { success: true };
    } else {
      return response.json().then((json) => ({ success: false, error: json }));
    }
  });
};

export const toggleCouponActive = (jwt, fleetId, couponId, isActive) => {
  const body = JSON.stringify({ is_active: isActive });
  const url = `${API_HOST_V2}/fleets/${fleetId}/coupons/${couponId}`;
  return fetch(url, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${jwt}`,
      'Content-Type': 'application/JSON',
    },
    body,
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const getRideTransactions = (jwt, ride_id) => {
  const url = `${API_HOST_V2}/fleets/rides/${ride_id}/transactions`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const getUserWaiver = (jwt, userId) => {
  if (!jwt) {
    return Promise.reject(new Error('JWT token is missing'));
  }
  
  if (!userId) {
    return Promise.reject(new Error('User ID is required'));
  }
  
  const url = `${API_HOST_V3}/users/waiver/${userId}`;
  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/JSON',
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (!response.ok) {
      const errorMessage = `Failed to fetch waiver (HTTP ${response.status})`;
      console.error(errorMessage);
      throw new Error(errorMessage);
    }
    return response.json();
  }).catch(error => {
    console.error('Error in getUserWaiver:', error);
    throw error; // Re-throw to allow component to handle it
  });
};

export const sendWaiverLink = (jwt, userId, method = 'email', operatorId) => {
  if (!jwt) {
    return Promise.reject(new Error('JWT token is missing'));
  }
  
  if (!userId) {
    return Promise.reject(new Error('User ID is required'));
  }
  
  const url = `${API_HOST_V3}/users/send-waiver-link`;
  const body = {
    user_id: userId,
    method: method, // 'email' or 'sms'
    operator_id: operatorId
  };
  
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (!response.ok) {
      const errorMessage = `Failed to send waiver link via ${method} (HTTP ${response.status})`;
      console.error(errorMessage);
      throw new Error(errorMessage);
    }
    return response.json();
  }).catch(error => {
    console.error(`Error sending waiver link via ${method}:`, error);
    throw error;
  });
};

// Add a participant to a reservation
export const addReservationParticipant = (jwt, reservationId, participantData, adminId = null) => {
  if (!jwt) {
    return Promise.reject(new Error('JWT token is missing'));
  }
  
  if (!reservationId) {
    return Promise.reject(new Error('Reservation ID is required'));
  }
  
  if (!participantData) {
    return Promise.reject(new Error('Participant data is required'));
  }
  
  // Support both phone-only and user-based participant data
  const body = {};
  
  if (participantData.phone) {
    body.phone = participantData.phone;
  }
  
  if (participantData.user_id) {
    body.user_id = participantData.user_id;
  }
  
  if (participantData.notes) {
    body.notes = participantData.notes;
  }
  
  // Add admin_id if provided
  if (adminId) {
    body.admin_id = adminId;
  }
  
  const url = `${API_HOST_V3}/fleet-admins/reservations/${reservationId}/add-participant`;
  
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (!response.ok) {
      return response.json().then(errorJson => {
        const errorMessage = errorJson.message || `Failed to add participant to reservation (HTTP ${response.status})`;
        console.error(errorMessage);
        throw new Error(errorMessage);
      }).catch(() => {
        const errorMessage = `Failed to add participant to reservation (HTTP ${response.status})`;
        console.error(errorMessage);
        throw new Error(errorMessage);
      });
    }
    return response.json();
  }).catch(error => {
    console.error('Error adding participant to reservation:', error);
    throw error;
  });
};

// Update a participant in a reservation (for modifying or removing participants)
export const updateReservationParticipant = (jwt, reservationId, userId, role = null, notes = null, is_active = true, adminId = null) => {
  if (!jwt) {
    return Promise.reject(new Error('JWT token is missing'));
  }
  
  if (!reservationId) {
    return Promise.reject(new Error('Reservation ID is required'));
  }
  
  if (!userId) {
    return Promise.reject(new Error('User ID is required'));
  }
  
  const url = `${API_HOST_V3}/fleet-admins/reservations/${reservationId}/update-participant`;
  const body = {
    userId,
    is_active
  };
  
  // Add optional parameters if provided
  if (role !== null) {
    body.role = role;
  }
  if (notes !== null) {
    body.notes = notes;
  }
  if (adminId) {
    body.admin_id = adminId;
  }
  
  return fetch(url, {
    method: 'PATCH',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (!response.ok) {
      return response.json().then(errorJson => {
        const errorMessage = errorJson.message || `Failed to update participant in reservation (HTTP ${response.status})`;
        console.error(errorMessage);
        throw new Error(errorMessage);
      }).catch(() => {
        const errorMessage = `Failed to update participant in reservation (HTTP ${response.status})`;
        console.error(errorMessage);
        throw new Error(errorMessage);
      });
    }
    return response.json();
  }).catch(error => {
    console.error('Error updating participant in reservation:', error);
    throw error;
  });
};

// Remove a participant from a reservation (wrapper around updateReservationParticipant)
export const removeReservationParticipant = (jwt, reservationId, userId) => {
  return updateReservationParticipant(jwt, reservationId, userId, null, null, false);
};

// Download waiver PDF using V3 endpoint
export const downloadWaiverPdf = (jwt, userId) => {
  if (!jwt) {
    return Promise.reject(new Error('JWT token is missing'));
  }
  
  if (!userId) {
    return Promise.reject(new Error('User ID is required'));
  }
  
  const url = `${API_HOST_V3}/users/waiver-pdf/${userId}`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  }).then((response) => {
    if (!response.ok) {
      const errorMessage = `Failed to download waiver PDF (HTTP ${response.status})`;
      console.error(errorMessage);
      throw new Error(errorMessage);
    }
    return response.blob();
  }).catch(error => {
    console.error('Error downloading waiver PDF:', error);
    throw error;
  });
};





